import { layouts } from '@ocean/ui'

export { default } from './ErrorWrapperLayout'
export type { SectionSpaceSize as VerticalSpaceType } from '@ocean/ui/dist/layouts/SectionSpaceLayout/types'

const { SectionSpaceSize: VerticalSpace } = layouts
export { VerticalSpace }
